import Card from './card.vue'
import CardGroup from './card-group.vue'
Card.Group = CardGroup
export default Card



// WEBPACK FOOTER //
// ./src/components/card/index.js